import { render } from "./GenderList.vue?vue&type=template&id=30a419d1&scoped=true"
import script from "./GenderList.vue?vue&type=script&lang=js"
export * from "./GenderList.vue?vue&type=script&lang=js"

import "./GenderList.vue?vue&type=style&index=0&id=30a419d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a419d1"]])

export default __exports__